import { observer } from "mobx-react";
import React from "react";

export type ImageLayout = 'wide' | 'landscape' | 'square' | 'portrait' | 'as-image';

type ImageLayoutPickerProps = {
  layout: ImageLayout;
  onSelect: (layout: ImageLayout) => void;
  imageAttached?: boolean;
  asImageSize?: { width: number; height: number };
};

export function getLayoutIcon(layout: ImageLayout): React.ReactNode {
  switch (layout) {
    case 'landscape':
      return (<svg width="32px" height="32px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="7" width="20" height="10" rx="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>);
    case 'square':
      return (<svg width="32px" height="32px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4" y="4" width="16" height="16" rx="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>);
    case 'portrait':
      return (<svg width="32px" height="32px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="7" y="2" width="10" height="20" rx="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>);
    case 'as-image':
      return (<svg width="32px" height="32px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="6" width="13" height="10" rx="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <rect x="8" y="9" width="13" height="10" rx="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>);
    default:
      return null;
  }
}

@observer
class ImageLayoutPicker extends React.Component<ImageLayoutPickerProps> {
  render() {
    const { layout, onSelect, imageAttached, asImageSize } = this.props;

    const aspectRatios: { ratio: string, name: string }[] = [
      /*{ 
        ratio: '3:1', 
        name: 'Wide'
      },*/ { 
        ratio: '16:9', 
        name: 'Landscape'
      }, { 
        ratio: '1:1', 
        name: 'Square'
      },
      { 
        ratio: '9:16', 
        name: 'Portrait'
      }
    ];

    const asImageTitle = asImageSize
      ? `As Image (${asImageSize.width}×${asImageSize.height})`
      : 'As Image (attach an image first)';

    return (
      <div className="control-group">
        <label>Layout:</label>
        <div className="layout-selector">
          {aspectRatios.map((ratio) => (
            <button
              key={ratio.name}
              className={'layout-btn' + (layout === ratio.name.toLowerCase() ? ' active' : '')}
              onClick={() => onSelect(ratio.name.toLowerCase() as ImageLayout)}
              title={`${ratio.name} (${ratio.ratio})`}
            >
              <span className="layout-icon">
                {getLayoutIcon(ratio.name.toLowerCase() as ImageLayout)}
              </span>
            </button>
          ))}
          <button
            key="as-image"
            className={'layout-btn' + (layout === 'as-image' ? ' active' : '') + (!imageAttached ? ' disabled' : '')}
            onClick={() => imageAttached && onSelect('as-image')}
            title={asImageTitle}
            disabled={!imageAttached}
            style={{ opacity: !imageAttached ? 0.5 : 1, cursor: !imageAttached ? 'not-allowed' : 'pointer' }}
          >
            <span className="layout-icon">
              {getLayoutIcon('as-image')}
            </span>
          </button>
        </div>
      </div>
    );
  }
  
  
}

export default ImageLayoutPicker;